<template>
    <div>
        <vs-row>
            <vs-col>
                <p class="h4 mt-5">{{ projectNames.plural }} à réaliser</p>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <vs-table
                    :sst="true"
                    @search="eventSearchItems"
                    @sort="eventSortByCol"
                    search
                    :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
                    style="width:100%"
                    :data="itemsData"
                >
                    <template slot="thead">
                        <vs-th width="100"></vs-th>
                        <vs-th>
                            <Sort name="last_name" @sort="eventSortByCol">Nom</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="first_name" @sort="eventSortByCol">Prénom</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="establishments,name" @sort="eventSortByCol">Établissements</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="services,title" @sort="eventSortByCol">Services</Sort>
                        </vs-th>
                        <vs-th>Expérience(s)</vs-th>
                        <vs-th>Métier(s)</vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template>
                        <vs-tr v-for="(item, i) in itemsData" :key="i">
                            <vs-td>
                                <vs-avatar
                                    v-if="get(item, ':photoUrl')"
                                    size="70px"
                                    :src="get(item, ':photoUrl')"
                                />
                                <vs-avatar
                                    v-else
                                    size="70px"
                                    :color="generateColor(get(item, ':name'))"
                                />
                            </vs-td>
                            <vs-td>
                                <a :href="'/rh/gestion/personnes/' + get(item, ':id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                    <b>{{ get(item, ":last_name") }}</b>
                                </a>
                            </vs-td>
                            <vs-td>
                                <a :href="'/rh/gestion/personnes/' + get(item, ':id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                    <b>{{ get(item, ":first_name") }}</b>
                                </a>
                            </vs-td>
                            <vs-td>
                                <a :href="'/rh/gestion/personnes/' + get(item, ':id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                {{ arrayUnique(get(item, ":services").map(s => s.establishment.name)).join(', ') }}
                                </a>
                            </vs-td>
                            <vs-td>
                                <a :href="'/rh/gestion/personnes/' + get(item, ':id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                {{ arrayUnique(get(item, ":services").map(s => s.title)).join(', ') }}
                                </a>
                            </vs-td>
                            <vs-td>
                                <ms-chip :color="getColorFor('job', index+1)" v-for="(el, index) in get(item, ':current_jobs')" :key="index">
                                    <b>{{ el.title }}</b>
                                </ms-chip>
                            </vs-td>
                            <vs-td>
                                <ms-chip :color="getColorFor('occupation', index+1)" v-for="(el, index) in get(item, ':current_occupations')" :key="index">
                                    <b>{{ el.title }}</b>
                                </ms-chip>
                            </vs-td>
                            <vs-td class="action">
                                <div class="action-wrapper">
                                    <vs-button
                                        v-if="canMulti('update', 'ratings', item.services.map(s => s.id))"
                                        :id="'createRatingEmployee_' + i"
                                        :href="`/rh/gestion/personnes/${item.id}/bilans/creer`"
                                        :v-tooltip="'Créer le '+projectNames.singular"
                                        color="primary"
                                        type="border"
                                        icon-pack="feather"
                                        icon="icon-plus-square"
                                    />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

                <vs-row>
                    <vs-col class="mt-4" v-if="items.total > 0">
                        <vs-pagination
                            :total="Math.ceil(items.total / apiParams.perpage)"
                            v-model="currentPage"
                        ></vs-pagination>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    name: "RatingsToPerform",
    props: {
        api: {
            type: String,
            required: true
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            currentPage: 1,
            loading: false,
        }
    },
    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },
    created() {
        this.apiParams.include = [
            'services.establishment',
            'currentJobs.occupation_skills',
            'currentJobs.service',
            'currentOccupations'
        ];
        this.apiParams.perpage = 5;
        this.loadItems();
    }
};
</script>
